import {createReducer, on} from '@ngrx/store';
import * as ProfileActions from './profile.actions';
import {Profile} from '../profile.model';
import {Location} from '../../location/location.model';

export interface ProfileState {
  profile?: Profile | null;
  loading?: boolean;
  error?: null;
  terms: any;
  locations: Location[];
}

export const initialState: ProfileState = {
  profile: undefined,
  loading: false,
  error: null,
  terms: null,
  locations: [],
};

export const profileFeatureKey = 'profile';

export const profileReducer = createReducer(
  initialState,

  // Profile
  on(ProfileActions.loadProfileSuccess, (state, {profile}) => ({
    ...state,
    profile,
    loading: false,
    error: null,
  })),
  on(ProfileActions.loadProfileError, (state) => ({
    ...state,
    profile: null,
    loading: false,
  })),

  // Locations
  on(ProfileActions.loadLocationsSuccess, (state, {locations}) => ({
    ...state,
    locations,
  })),

  // Logout
  on(ProfileActions.logoutSuccess, () => ({
    ...initialState
  }))
);
